import type { Cartesian3, Viewer } from '@cesiumgs/cesium-analytics'
import { CallbackProperty, Color, Entity, ScreenSpaceEventType, defined } from '@cesiumgs/cesium-analytics'
import type { DrawResult } from './DrawResult'
import DrawAction from './DrawAction'
import { type DrawOptions } from './DrawOptions'

/**
 * Cesium Tool for Draw Line
 * @example
 * ```typescript
 * let draw=new Draw(view);
 * draw.create(DrawType.Polyline,null);
 * draw.on(DrawEventType.CursorUpdate,evt=>{
 * });
 * ```
 */
export default class DrawLineAction extends DrawAction {
  /**
   * @internal
   */
  renderResult: Array<Cartesian3> = []
  /**
   * @internal
   */
  addEntity: Entity | undefined
  /**
   *
   * @internal
   */
  vertexAddHandler(movement: any): void {
    if (this.state === 'end') {
      this.state = 'start'
    }
    const ray = this.viewer.camera.getPickRay(movement.position)
    if (ray) {
      const position = this.viewer.scene.globe.pick(ray, this.viewer.scene)
      if (defined(position)) {
        if (position) {
          this.drawResults?.postions.push(position)
        }
        this.addEvt.raiseEvent(this.drawResults as any)
        this.renderResult = this.drawResults?.postions
      }
    }
  }

  /**
   *
   * @internal
   */
  vertexCompleteHandler(movement: any): void {
    // let position = this.viewer.scene.pickPosition(movement.position);

    this.viewer.trackedEntity = undefined
    this.renderResult = this.drawResults?.postions
    this.removeListener()
    this.complete()
  }

  /**
   *
   * @internal
   */
  cursorUpdateHandler(movement: any): void {
    if (this.state === 'start') {
      const ray = this.viewer.camera.getPickRay(movement.endPosition)
      if (ray) {
        const position = this.viewer.scene.globe.pick(ray, this.viewer.scene)
        if (defined(position)) {
          const res: DrawResult = {
            postions: [...this.drawResults.postions as any, position],
          }
          this.renderResult = res.postions

          this.updateEvt.raiseEvent(res as any)
        }
      }
    }
  }

  /**
   *
   * @internal
   */
  registerViewerEvent(): void {
    this.vertexAddHandlerInstance?.setInputAction(
      this.vertexAddHandler.bind(this),
      ScreenSpaceEventType.LEFT_CLICK,
    )
    this.vertexCompleteHandlerInstance?.setInputAction(
      this.vertexCompleteHandler.bind(this),
      ScreenSpaceEventType.RIGHT_CLICK,
    )
    this.cursorUpdateHandlerInstance?.setInputAction(
      this.cursorUpdateHandler.bind(this),
      ScreenSpaceEventType.MOUSE_MOVE,
    )
  }

  /**
   *
   * @internal
   */
  removeListener(): void {
    this.vertexAddHandlerInstance?.removeInputAction(
      ScreenSpaceEventType.LEFT_CLICK,
    )
    this.vertexCompleteHandlerInstance?.removeInputAction(
      ScreenSpaceEventType.RIGHT_CLICK,
    )
    this.cursorUpdateHandlerInstance?.removeInputAction(
      ScreenSpaceEventType.MOUSE_MOVE,
    )
  }

  /**
   *
   * @internal
   */
  constructor(viewer: Viewer, options?: DrawOptions) {
    super(viewer, options)
    this.type = 'line'
    if (this.drawoptions?.useDefaultEntity) {
      const addEntity
        = this.drawoptions?.defaultLineEntity
        || new Entity({
          polyline: {
            clampToGround: true,
            positions: new CallbackProperty(() => {
              return this.renderResult
            }, false),
            width: 5,
            material: Color.fromCssColorString('#FFD040'),
          },
        })

      this.addEntity = this.dataSource.entities.add(addEntity)
    }
  }
}
